import {noop, template} from "lodash";
import {
    Add_Map, Area_Code,
    Batch_Search,
    Batch_Sync_Status, Batch_Sync_trigger,
    Cargo_Owner_Carrier_Edit,
    Cargo_Owner_Discount_Add,
    Cargo_Owner_Discount_Edit,
    Cargo_Owner_Info, Cargo_Owner_Storage_Fee_Term_Edit, Change_ASN_Submit,
    Change_Customer_Active,
    Change_Order_Status,
    Check_Product_Sku,
    Choice_Owner,
    Create_Kit, Create_Kitting,
    Create_Product,
    Dict_Type,
    Download_Product_Template, Edit_Customer,
    Edit_Kit,
    Edit_Map,
    Edit_Product, Export_Inbound, Export_Invalid_Packaging_List,
    Export_Inventory_Batch,
    Export_Inventory_Product, Export_Kitting, Export_Packaging_List,
    Export_Product_List, Export_Wholesale,
    Filter_Customer, Filter_Invalid_Packaging,
    Filter_Map,
    Filter_Owner,
    Filter_Packaging, Import_Customer,
    Kit_Detail, Kitting_Cancel, Kitting_Detail, Kitting_Edit, Kitting_Submit,
    Map_Info,
    Modify_Kit_Status,
    Modify_SKU_Status,
    Package_Information, Product_Batch_Import,
    Product_Detail,
    Product_Search,
    Product_sku,
    Remove_Kit,
    Remove_Product,
    Search_Kit, Search_Kitting,
    Search_Package,
    Search_Products, Sku_Batch_Import,
    Sku_Choice, Sku_Safe_Batch_Import,

} from "../../config";
import api from "../../api/api";
import LocalStorage from "../../utils/LocalStorage";
import {onSuccessAlert} from "../message/messageActions";
import moment from "moment";
import {CustomerActionType} from "../customer/customerAction";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import {getAdminOwners} from "../../utils/globalFunction";

export const InventoryActionType = {
    PRODUCT_FILTER:"PRODUCT_FILTER",
    PRODUCT_STATE_LIST:"PRODUCT_STATE_LIST",
    PRODUCT_CATEGORY_LIST:"PRODUCT_CATEGORY_LIST",
    WAREHOUSE_LIST:'WAREHOUSE_LIST',
    PACKAGE_LIST:"PACKAGE_LIST",
    CURRENT_PRODUCT:"CURRENT_PRODUCT",
    BATCH_SEARCH_LIST:'BATCH_SEARCH_LIST',
    PRODUCT_SEARCH_LIST:'PRODUCT_SEARCH_LIST',
    KIT_FILTER:'KIT_FILTER',
    SKU_CHOICE_PRODUCT:'SKU_CHOICE_PRODUCT',
    CURRENT_KIT:'CURRENT_KIT',
    PACKAGE_SEARCH_LIST:'PACKAGE_SEARCH_LIST',
    CUSTOMER_SEARCH_LIST:'CUSTOMER_SEARCH_LIST',
    MAP_LIST:'MAP_LIST',
    PLATFORM_LIST:'PLATFORM_LIST',
    OWNER_LIST:'OWNER_LIST',
    OWNER_INFO:'OWNER_INFO',
    OWNER_INFO_RESET:'OWNER_INFO_RESET',
    AREA_CODE:'AREA_CODE'
}

export const getAllWarehouseList = (onSuccess = noop, onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_ware_house_list'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:InventoryActionType.WAREHOUSE_LIST,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const change_batch_sync = (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try{

        if (!checkPermission(PERMISSION_DICT.InventoryProductSync)) return null;
        const url = `${Batch_Sync_Status}`
        const response = await api.post(url,data)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    }
    catch (e) {

        onError(e.message)
    }
}

export const trigger_batch_sync = (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try{

        if (!checkPermission(PERMISSION_DICT.InventoryProductSyncTrigger)) return null;
        const url = `${Batch_Sync_trigger}`
        const response = await api.post(url,data)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    }
    catch (e) {

        onError(e.message)
    }
}


export const getAllPlatformList = (onSuccess = noop, onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_plat_code_list'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:InventoryActionType.PLATFORM_LIST,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const check_product_sku = (data,onSuccess = noop, onError = noop)  => async () => {
    try{

        if (!checkPermission(PERMISSION_DICT.InventoryProductCheckUnique)) return null;

        const cleanedData = {
            ...data,
            sku: data?.sku?.trim() || '', // 去除前后空格，防止 undefined 报错
        };

        const url = `${Check_Product_Sku}`
        const response = await api.post(url,cleanedData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(true)

        } else if((response?.status === 200 && response.data.code === 500)){
            onSuccess(false)
        }
        else {
            onError(response?.data?.msg)
        }
    } catch (e) {
        onError(e.message)
    }
}

export const packInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        const url = `${Package_Information}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(response?.data?.data)
        } else {
            onError(response?.data?.msg)
        }

    } catch (e) {
        onError(e?.message)
    }
}

export const productInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.InventoryProductInfo)) return null;
        const url = `${Product_Detail}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:InventoryActionType.CURRENT_PRODUCT,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const downloadProductsListInfo = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.InventoryProductExport)) return null;
        const xurl = `${Export_Product_List}`;
        const response = await api.post(xurl, {...data}, {
            responseType: 'blob' // 设置响应类型为 Blob
        });

        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `SKUs_Information_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const mapInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InventorySkuMappingInfo)) return null;
        const url = `${Map_Info}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}


export const editProduct =(data,onSuccess = noop, onError = noop)  => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.InventoryProductModify)) return null;
        const url = `${Edit_Product}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response?.data?.code === 200){

            onSuccess('ProductPage.Edit Successfully')
        } else {
            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}



export const downloadKitTemplate = (onSuccess= noop, onError = noop) => async () =>{

    try{
        const xurl = `${Download_Product_Template}`
        const customer = !checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        const fileName = customer ? 'Customer_Kit_Template.xlsx':'Kit_Template.xlsx'
        const response = await api.get(xurl,{params: { fileName: fileName },
            responseType: 'blob' })

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Kit_Template_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            console.error('Failed to download file. Server responded with status:', response.status);
            onError(`Failed to download file. Server responded with status:${response.status}`)
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadProductTemplate = (onSuccess= noop,onError = noop) => async () =>{
    
    try{
        const xurl = `${Download_Product_Template}`
        const customer = !checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        const fileName = customer ? 'Customer_Commodity_Entry_Template.xlsx':'Commodity_Entry_Template.xlsx'
        const response = await api.get(xurl,{params: { fileName: fileName },
            responseType: 'blob' })
            .then(res=> res)

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Commodity_Entry_Template_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }
    
}

export const downloadSkuDiscountTemplate = (onSuccess= noop,onError = noop) => async () =>{

    try{
        const xurl = `${Download_Product_Template}`
        const customer = !checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        const fileName = customer ? 'Owner_Commodity_Safety_Inventory_Template.xlsx':'Admin_Commodity_Safety_Inventory_Template.xlsx'
        const response = await api.get(xurl,{params: { fileName: fileName },
            responseType: 'blob' })
            .then(res=> res)

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Commodity_Safety_Inventory_Template${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadBatchInfo = (data,onSuccess= noop,onError = noop) => async () =>{

    try {
        if (!checkPermission(PERMISSION_DICT.InventoryStockBatchExport)) return null;


        const xurl = `${Export_Inventory_Batch}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });


        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Inventory_Stock_Batch_Information_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const downloadProductInfo = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.InventoryStockProductExport)) return null;
        const xurl = `${Export_Inventory_Product}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });


        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Inventory_Stock_Product_Information_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}



export const downloadSKUMappingTemplate = (onSuccess= noop) => async () =>{

    try{
        const xurl = `${Download_Product_Template}`
        const customer = !checkPermission(PERMISSION_DICT.QueryOwnerInfo)
        const fileName = customer ? 'Customer_Sku_Mapping_Template.xlsx':'Sku_Mapping_Template.xlsx'
        const response = await api.get(xurl,{params: { fileName: fileName },
            responseType: 'blob' })
            .then(res=> res)

        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `SKU_Mapping_Template_${moment().format('YYYYMMDD')}.xlsx`
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName)
        } else {
            console.error('Failed to download file. Server responded with status:', response.status);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const removeKit =(data,onSuccess = noop, onError = noop)  => async () => {

    try {
        const url = `${Remove_Kit}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.msg)
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}

export const removeProduct =(data,onSuccess = noop, onError = noop)  => async () => {

    try {
        const url = `${Remove_Product}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response.data.msg)
        } else {
            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}

export const importBatchSkuSafe = (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InventoryProductSafety)) return null;
        const url = `${Sku_Safe_Batch_Import}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response?.data?.code === 200){

            onSuccess(response.data.data)
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }

}

export const importProductList = (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InventoryProductUpload)) return null;
        const url = `${Product_Batch_Import}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response?.data?.code === 200){

            onSuccess(response.data.data)
        } else {

            onError(response?.data?.msg)
        }

    }
    catch (e) {
        onError(e?.message)
    }

}

export const addProduct =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InventoryProductAdd)) return null;
        const url = `${Create_Product}`
        const response = await api.post(url,{...data})
        .then(res=>res)


        if(response?.status === 200 && response?.data?.code === 200){

            onSuccess("ProductPage.add product successfully")
        } else {

            onError(response?.data?.msg)
        }

        }
    catch (e) {
        onError(e?.message)
    }

}



export const searchPackage =  (data,onSuccess = noop,onError=noop)  => async dispatch => {
    try {
        const url = `${Search_Package}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:InventoryActionType.PACKAGE_LIST,
                payload:response.data.data
            })
            onSuccess(response?.data?.data)
        } else {
            onError(response?.data?.msg)
        }

    } catch (e) {
        onError(e?.message)
    }
}


export const productStateList = (onSuccess = noop, onError = noop)  => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_product_state_list'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:InventoryActionType.PRODUCT_STATE_LIST,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }


}

export const productCategoryList = (onSuccess = noop, onError = noop) => async dispatch => {
    try {
        const url = `${Dict_Type}`
        const response = await api.get(url,{params:{dictType:'sys_category_code_list'}} )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){

            dispatch({
                type:InventoryActionType.PRODUCT_CATEGORY_LIST,
                payload:response.data.data
            })
            onSuccess(response.data.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }

    } catch (e) {
        onError(e.message)
    }


}


export const ownerSelected= (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.QueryOwnerInfo)) return null;


        const url = `${Choice_Owner}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(response?.data?.data)
        }

    }catch (e) {
        onError(e.message)
    }
}

export const getFilteredOwners= (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.QueryOwnerInfo)) return null;
        const ownerList = getAdminOwners(LocalStorage?.getItem('username'))
        if (ownerList?.length > 0) {
            const condition = data?.condition?.toLowerCase()?.trim()
            const res = ownerList?.filter((ele)=>ele?.ownerId?.toLowerCase()?.trim()?.indexOf(condition) >= 0 || ele?.ownerName?.toLowerCase()?.trim()?.indexOf(condition) >= 0)
            onSuccess(res)
        }else {
            const url = `${Choice_Owner}`
            const response = await api.post(url, {...data})
                .then(res=>res)

            if(response?.status === 200 && response.data.code === 200){
                onSuccess(response?.data?.data)
            }
        }

    }catch (e) {
        onError(e.message)
    }
}

export const change_sku_status = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InventoryProductModifyStatus)) return null;

        const url = `${Modify_SKU_Status}`
        const response = await api.post(url,{...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`${response.data.msg}`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const change_kit_status = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.InventoryKitModifyStatus)) return null;
        const url = `${Modify_Kit_Status}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`${response.data.msg}`)
        } else {
            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const skuProductSelected= (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.InventoryStockSku)) return null;
        const url = `${Product_sku}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)

            if(response?.status === 200 && response.data.code === 200){
                onSuccess(response.data.data)
            }

        }catch (e) {
            onError(e.message)
        }
}

export const productFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.InventoryProductList)) return null;
        const url = `${Search_Products}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.PRODUCT_FILTER,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}



export const editKit = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.InventoryKitModify)) return null;
        const url = `${Edit_Kit}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`${response.data.msg}`)
        } else {
            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const editMapping = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.InventorySkuMappingModify)) return null;
        const url = `${Edit_Map}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            onSuccess(`${response.data.msg}`)
        } else {
            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}



export const createKit = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.InventoryKitAdd)) return null;
        const url = `${Create_Kit}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('KitPage.Kit created successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const kitInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InventoryKitInfo)) return null;
        const url = `${Kit_Detail}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:InventoryActionType.CURRENT_KIT,
                payload:response.data.data
            })

            onSuccess(response.data.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const kitProduct = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.choiceSkuList)) return null;

        const url = `${Sku_Choice}`
        const response = await api.get(url,
            {params:{ownerId:data?.ownerId ? data?.ownerId : ""
                    // ,sku:data.sku,barcode:''
            }}
        )
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:InventoryActionType.SKU_CHOICE_PRODUCT,
                payload:response.data.data.filter(prod => prod.packages !== null && prod?.packages?.length !== 0)
            })
            onSuccess(response.data.data.filter(prod => prod.packages !== null && prod?.packages?.length !== 0))
        } else {
            onError(response.data.msg,response?.data.code)
        }
    }
    catch (e) {
        onError(e.message)
    }
}

export const kitFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.InventoryKitList)) return null;
        const url = `${Search_Kit}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.KIT_FILTER,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}

export const mapFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.InventorySkuMappingList)) return null;

        const url = `${Filter_Map}`

        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.MAP_LIST,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}


export const addMapping =  (data,onSuccess = noop, onError = noop)  => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InventorySkuMappingAdd)) return null;
        const url = `${Add_Map}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess("MappingPage.SKU mapping created successfully")
        } else {

            onError(response.data.msg)
        }

    }
    catch (e) {
        onError(e.message)
    }

}



// export const change_Customer_Active = (data,onSuccess = noop, onError = noop) => async dispatch => {
//     try {
//
//         if (!checkPermission(PERMISSION_DICT.OwnerCustomerChangeStatus)) return null;
//         const url = `${Change_Customer_Active}`
//         const response = await api.post(url,{...data})
//             .then(res=>res)
//
//         if(response?.status === 200 && response.data.code === 200){
//
//             onSuccess(`Update ${response.data.msg} active status successfully`)
//         } else {
//             onError(response.data.msg)
//         }
//
//     } catch (e) {
//         onError(e.message)
//     }
// }

export const change_Customer_Active = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.OwnerCustomerModify)) return null;
        const url = `${Edit_Customer}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`${response.data.msg}`)
        } else {
            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}





export const customerFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.OwnerCustomerList)) return null;
        const url = `${Filter_Customer}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.CUSTOMER_SEARCH_LIST,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}


export const packagingFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.InventoryPackagingList)) return null;
        const url = `${Filter_Packaging}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.PACKAGE_SEARCH_LIST,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}

export const packagingInvalidFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.InventoryPackagingList)) return null;
        const url = `${Filter_Invalid_Packaging}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.PACKAGE_SEARCH_LIST,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}


export const downloadInvalidPackageList = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.InventoryPackagingExport)) return null;

        const xurl = `${Export_Invalid_Packaging_List}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });

        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Invalid_Packaging_List_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}


export const downloadPackageList = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.InventoryPackagingExportInvalid)) return null;

        const xurl = `${Export_Packaging_List}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });

        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200 && !jsonResponse) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Packaging_List_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: Request failed`);
        }
    }

}


export const batch_Search = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.InventoryStockBatch)) return null;
        const url = `${Batch_Search}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.BATCH_SEARCH_LIST,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const batchSearchReactQuery = async (data) => {
    try {
        if (!checkPermission(PERMISSION_DICT.InventoryStockBatch)) {
            throw new Error('No permission to search batch inventory');
        };
        if (!data) {
            // react-query 不允许 undefined
            return { rows: [], total: 0 };
        }
        const url = `${Batch_Search}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res => res)

        if (response?.status === 200 && response.data.code === 200) {
            return response.data
        } else {

            // onError(response.data.msg,response?.data.code)
            throw new Error(response.data.msg);
        }

    } catch (e) {
        throw new Error('Batch inventory search failed');
    }
}

export const productSearch = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {
        if (!checkPermission(PERMISSION_DICT.InventoryStockProduct)) return null;

        const url = `${Product_Search}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.PRODUCT_SEARCH_LIST,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {

            onError(response.data.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const productSearchReactQuery = async (data) => {
    try {
        if (!checkPermission(PERMISSION_DICT.InventoryStockProduct)) {
            throw new Error('No permission to search product inventory');
        };
        if (!data) {
            // react-query 不允许 undefined
            return { rows: [], total: 0 };
        }
        const url = `${Product_Search}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res => res)

        if (response?.status === 200 && response.data.code === 200) {
            return response.data
        } else {

            // onError(response.data.msg,response?.data.code)
            throw new Error(response.data.msg);
        }

    } catch (e) {
        throw new Error('Product inventory search failed');
    }
}


export const ownerFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.CustomerCargoList)) return null;
        const url = `${Filter_Owner}`
        const response = await api.post(url, {...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.OWNER_LIST,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}

export const cargoOwnerInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.CustomerCargoInfo)) return null;
        const url = `${Cargo_Owner_Info}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:InventoryActionType.OWNER_INFO,
                payload:response.data
            })
            onSuccess(response.data.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const cargoOwnerInfoReset = (onSuccess = noop, onError = noop) => async dispatch => {
    try {
            dispatch({
                type:InventoryActionType.OWNER_INFO_RESET,
                payload:""
            })
    } catch (e) {

        onError(e.message)
    }
}


export const cargoOwnerDiscountAdd= (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.CustomerCargoDiscountAdd)) return null;
        const url = `${Cargo_Owner_Discount_Add}`
        const response = await api.post(url,{...data})
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){

            onSuccess('CustomerPage.Cargo Owner Discount Add Successfully.')
        } else {
            // onError('Cargo Owner Discount Add failed.')
            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const cargoOwnerDiscountEdit= (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.CustomerCargoDiscountModify)) return null;
        const url = `${Cargo_Owner_Discount_Edit}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            onSuccess('CustomerPage.Cargo Owner Discount Edit Successfully.')
        } else {
            onError('Cargo Owner Discount Edit failed.')
        }

    } catch (e) {

        onError(e.message)
    }
}


export const cargoOwnerCarrierEdit= (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.CustomerCargoCarrierModify)) return null;
        if (data?.acceptedCarriers.length === 0) {
            onError( 'Cargo owner needs at least one carrier.')
            return
        }
        const url = `${Cargo_Owner_Carrier_Edit}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if((response?.status === 200 && response.data.code === 200) || response.code === 200 ){
            onSuccess('CustomerPage.Cargo Owner Carrier Edit Successfully.')
        } else {
            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}

export const cargoOwnerStorageFeeTermEdit= (data, onSuccess = noop, onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.CustomerCargoStorageFeeTermModify)) return null;
        const url = `${Cargo_Owner_Storage_Fee_Term_Edit}`
        const response = await api.post(url,{...data})
            .then(res=>res)
        if((response?.status === 200 && response.data.code === 200) || response.code === 200 ){
            onSuccess('Cargo Owner Storage Fee Term Edit Successfully.')
        } else {
            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}


export const getAreaCodeList = (onSuccess = noop, onError = noop) => async dispatch => {
    try {
        const url = `${Area_Code}`
        const response = await api.post(url,null )
            .then(res=>res)
        if(response?.status === 200 && response.data.code === 200){
            dispatch({
                type:InventoryActionType.AREA_CODE,
                payload:response.data.rows
            })
        } else {
            onError(response?.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }


}

export const createKitting = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.InventoryKittingAdd)) return null;
        const url = `${Create_Kitting}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('KitPage.Kitting created successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const kitting_submit = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InventoryKittingSubmit)) return null;
        const url = `${Kitting_Submit}`
        let requestData = {...data}
        const response = await api.post(url,requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`KitPage.Submit Kitting successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const kitting_cancel = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InventoryKittingCancel)) return null;
        const url = `${Kitting_Cancel}`
        let requestData = {...data}
        const response = await api.post(url,requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){

            onSuccess(`KitPage.Cancel Kitting successfully`)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {
        onError(e.message)
    }
}

export const editKitting = (data, onSuccess = noop,onError = noop) => async dispatch => {
    try {
        if (!checkPermission(PERMISSION_DICT.InventoryKittingEdit)) return null;
        const url = `${Kitting_Edit}`
        const response = await api.post(url, {...data})
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            onSuccess('KitPage.Kitting edited successfully')
        } else {

            onError(response.data?.msg,response?.data.code)
        }

    }
    catch (e) {
        onError(e.message)
    }
}

export const kittingFilter = (data, onSuccess = noop,onError = noop) => async dispatch => {

    try {

        if (!checkPermission(PERMISSION_DICT.InventoryKittingList)) return null;
        const url = `${Search_Kitting}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url, requestData)
            .then(res=>res)


        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.KIT_FILTER,
            //     payload:response.data
            // })
            onSuccess(response.data)
        } else {
            onError(response.data.msg,response?.data.code)
        }
    } catch (e) {
        onError(e.message)
    }

}

export const downloadKittingInfo = (data,onSuccess= noop,onError = noop) => async () =>{

    try {

        if (!checkPermission(PERMISSION_DICT.InventoryKittingExport)) return null;
        const xurl = `${Export_Kitting}`;
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(xurl, requestData, {
            responseType: 'blob' // 设置响应类型为 Blob
        });



        // 尝试将 Blob 转换为文本以检查是否有错误消息
        const text = await response.data.text();
        let jsonResponse;
        try {
            jsonResponse = JSON.parse(text);
        } catch (e) {
            // 解析失败，说明响应是一个有效的 Blob 文件
            jsonResponse = null;
        }

        if (response.status === 200 && jsonResponse && jsonResponse.code === 500) {
            // 服务器返回了200但响应体中包含错误码500
            onError(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
            console.error(`Failed to download file. Server responded with code: ${jsonResponse.code}, message: ${jsonResponse.msg}`);
        } else if (response.status === 200) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // 根据响应头中的 content-type 创建 Blob 对象
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const fileName = `Kitting_Details_${moment().format('YYYYMMDD')}.xlsx`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // 清理临时 URL 对象
            window.URL.revokeObjectURL(url);
            link.parentNode.removeChild(link);
            onSuccess(fileName);
        } else {
            onError(`Failed to download file. Server responded with status: ${response.status}`);
            console.error(`Failed to download file. Server responded with status: ${response.status}`);
        }
    } catch (error) {
        if (error.response) {
            // 请求已发出，服务器响应了状态码范围在 2xx 之外
            console.error('Error response status:', error.response.status);
            console.error('Error response data:', error.response.data);
            onError(`Error occurred while downloading file: Server responded with status ${error.response.status}`);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('Error request:', error.request);
            onError('Error occurred while downloading file: No response received from server');
        } else {
            // 其他错误
            console.error('Error:', error.message);
            onError(`Error occurred while downloading file: ${error.message}`);
        }
    }

}

export const kittingInfo = (data,onSuccess = noop, onError = noop) => async dispatch => {
    try {

        if (!checkPermission(PERMISSION_DICT.InventoryKittingInfo)) return null;
        const url = `${Kitting_Detail}`
        let requestData = {...data}
        delete requestData.userName
        const response = await api.post(url,requestData)
            .then(res=>res)

        if(response?.status === 200 && response.data.code === 200){
            // dispatch({
            //     type:InventoryActionType.CURRENT_KIT,
            //     payload:response.data.data
            // })

            onSuccess(response.data.data)
        } else {

            onError(response.data.msg)
        }

    } catch (e) {

        onError(e.message)
    }
}
